package one.healthium.health_tools.ui.models

import androidx.compose.runtime.Immutable

@Immutable
data class WaterIntakeUiModel(
    val dailyAmount: Float,
    val currentValue: Float,
) {
    val progress: Float = if (dailyAmount == 0f) 0f else currentValue / dailyAmount
}
